import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { InventorySecurityDaysTable } from '../../../../../../../../../../features/inventory/security-day/inventory-security-days-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsInventory,
      label: 'Balance',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsInventory>,
  head: () => getPageHead('Inventory Balances'),
  component: InventoryBalanceList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsInventory}
    />
  );
}

function InventoryBalanceList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <InventorySecurityDaysTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
